import {Injectable} from '@angular/core';
import {TUI_RUSSIAN_LANGUAGE} from '@taiga-ui/i18n';
import {AmountCartMethod, LoginBy, RecoverPasswordBy, SignUpBy} from '../vars';

@Injectable({
  providedIn: 'root'
})
export abstract class Environment {
  abstract isOpenCabinet: boolean;
  abstract serverApi: string;
  abstract serverUrl: string;

  production = false;
  accessRolesCatalog = false;
  serviceWorkers = false;
  serverPicturesPath = 'http://localhost:8086/pictures';
  serverDocumentsPath = 'http://localhost:8086/documents';
  youTubeShortLink = 'https://i.ytimg.com/vi/';
  companyName = 'Compo';

  codeField = 'codes.elcom';
  tokenName = 'Bearer';
  visibleSelectTagCount = 5;
  toastrNotificationDuration = 5000;
  gridPaginationRange = 25;
  dateFormat = 'dd.MM.yyyy';
  dadataToken = '6176f37b5bc4b5ff40f82e3108a4f9300a1d108e';
  ymapsApiKey = '';
  originalsImagesFolder = 'originals';
  documentFolder = 'documents';
  locale = 'ru';
  tuiLanguage = TUI_RUSSIAN_LANGUAGE;
  amountCartMethod = AmountCartMethod.UNIQUE;
  useProductTemplateFeatures = true;
  useYandexGPT = true;
  damTemplateId = 411;
  enableDescriptionGenerateAiButton = true;
  showDiscountPanel = false;
  companyTypes = ['Юр. лицо', 'ИП'];
  loginBy = LoginBy.PHONE;
  impersonate = true;
  impersonatePortalPath = 'http://localhost:4200/cabinet/sign-in';
  flatCodeAnalogAndRelated = 'elcom';
  recoverPasswordBy = RecoverPasswordBy.EMAIL; // email or sms
  maxHtmlContentLength = 300;
  maxTextAreaLength = 200;
  maxInputLength = 50;
  enableWorkflowButton = true;

  /**
   * Origin витрины (cabinet), выведенный из `impersonatePortalPath`. Через `new URL`, а не
   * срезом строки: в test и stage в пути одна косая (`https:/host/...`), URL-парсер её
   * исправляет. Пусто, если путь не разбирается.
   */
  get cabinetHost(): string {
    try {
      return new URL(this.impersonatePortalPath).origin;
    } catch {
      return '';
    }
  }
}

export class EnvironmentAdmin extends Environment {
  isOpenCabinet = false;
  serverApi = 'http://localhost:8086/api/v1';
  serverUrl = 'http://localhost:8086';
}

export class EnvironmentCabinet extends Environment {
  isOpenCabinet = true;
  serverApi = 'http://localhost:8080/api/v1';
  serverUrl = 'http://localhost:8080';
  notificationCustomerAccess = true;
  loadedRoutes = {
    // Default is SignUpBy.EMAIL and login by email, 2 steps registration form, no sms phone verification required
    signupFormType: SignUpBy.SMS
  };
  allowAnonymousView = false;
}
